import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { firebaseAuth } from '../hooks/use-firebase-app';

export const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_HOST_API + "/api/v1",
    prepareHeaders: async (headers) => {
        const user = firebaseAuth.currentUser;

        if (user) {
            const accessToken = await user.getIdToken(true);
            headers.set('Authorization', `Bearer ${accessToken}`);
        } else {
            const { getSessionToken } = require('../auth/context/jwt/utils');
            const fallbackToken = getSessionToken();
            if (fallbackToken) {
                headers.set('Authorization', `Bearer ${fallbackToken}`);
            }
        }

        headers.set('Content-Type', 'application/json');
        return headers;
    },
    timeout: 600000 // 10 Minutes
});